import { i18n } from '@/translate';
import { Notification } from 'element-ui';
import { prepareErrorMessageForNotAcceptableStatus } from './errorsMessages';

/**
 * Authorization interceptor
 *
 * @param {any} config
 * @returns
 */
export const authInterceptor = () => {

};

export const errorHandlerInterceptor = (error) => {
  const errorMessage = i18n.tc(`http_errors.${error.response ? error.response.status : 500}`);
  const errorDescription = error.response.data.data.value ? error.response.data.data.value[0] : '';

  Notification.error({
    title: errorMessage,
    message: errorDescription.charAt(0).toUpperCase() + errorDescription.slice(1),
    ...error.response.status === 406 && prepareErrorMessageForNotAcceptableStatus(error.response.data.data, error.response.config.url),
  });

  return Promise.reject(error);
};



// WEBPACK FOOTER //
// ./src/config/interceptors.js